import React, { useState } from 'react'
import http from '../../http'
import Fetch from '../../components/Fetch'
import { ColumnsContext } from '../../context/Columns'
import { withReload } from '../../context/Reload'
import T, { Pager } from '../../components/Table'

const Table = ( props ) => {
  const [ query, setQuery ] = useState( {} )
  const {
    before,
    client,
    withReload: { reload }
  } = props

  if ( ! client )
    return

  return (
        <ColumnsContext.Consumer>
          { context => ( <>
            <div className="hs one overflow-hidden">
              <Fetch
                type="table"
                endpoint={ `/api/dataSource/${ client }/whitelist/list` }
                before={ before }
                query={ query }
                useFilter={ true }
              >
                { ( data, update ) => (
                  <div className="hs card table full">
                    <T
                      data={ data.page }
                      columns={ context.columns }
                      prefix={ `/api/dataSource/${ client }/whitelist` }
                      actions={ [
                        {
                          icon: 'FiEdit2',
                          title: 'edit',
                          modal: 'EditRow',
                          params: {
                            endpoint: `/api/dataSource/${ client }/whitelist/update`,
                            client,
                            prefix: `/api/dataSource/${ client }/whitelist`
                          }
                        },
                        {
                          icon: 'FiTrash',
                          title: 'delete',
                          modal: 'Confirm',
                          message: 'do you want to delete this row?',
                          buttons: [
                            {
                              icon: 'FiCheck',
                              label: 'yes',
                              type: 'yes',
                              action: ( it ) => {
                                http( {
                                  url: `/api/dataSource/${ client }/whitelist/delete`,
                                  method: 'DELETE',
                                  data: { _id: it.row._id }
                                } )
                                  .then( response => {
                                    reload()
                                    it.close()
                                  } )
                              }
                            },
                            {
                              icon: 'FiX',
                              label: 'no',
                              type: 'no',
                              action: ( it ) => {
                                it.close()
                              }
                            }
                          ]
                        }
                      ] }
                    />

                    { data.page.length !== 0 ? (
                      <Pager
                        data={ data }
                        updateParams={ setQuery }
                      />
                    ) : null }
                  </div>
                ) }
              </Fetch>
            </div>
          </> ) }
        </ColumnsContext.Consumer>
  )
}

export default withReload( Table )
